"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GiftBoxFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GiftBoxFilled = function GiftBoxFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.973 3.844c-.353.229-.958.492-1.951.603.521-1.225 1.48-1.947 2.104-1.947.313 0 .499.162.499.432 0 .305-.244.646-.652.912zm-5.946 0c-.408-.265-.652-.605-.652-.91 0-.271.19-.434.508-.434.62 0 1.573.722 2.094 1.947-.993-.111-1.597-.373-1.95-.603zM14.5 5h-2.57c.759-.545 1.195-1.29 1.195-2.068 0-1.101-.86-1.932-1.999-1.932C9.953 1 8.765 1.877 8 3.164 7.235 1.877 6.05 1 4.883 1c-1.144 0-2.008.832-2.008 1.934 0 .778.436 1.521 1.194 2.066H1.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5H2v6.5a.5.5 0 00.5.5h4.75V7h1.5v8h4.75a.5.5 0 00.5-.5V8h.5a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5z",
    fill: "currentColor"
  }));
};

exports.GiftBoxFilled = GiftBoxFilled;
var _default = GiftBoxFilled;
exports.default = _default;